
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { showSuccessToast } from "@/utils/toast-utils";

const EmailConfirmed = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check for the current session
    const checkSession = async () => {
      const { data, error } = await supabase.auth.getSession();
      
      if (error) {
        console.error("Error checking session:", error);
        return;
      }
      
      // If we have a session and the email is confirmed, show a success toast
      if (data.session?.user?.email_confirmed_at) {
        showSuccessToast({
          title: "Email Successfully Verified",
          description: "Your account is now active."
        });
      }
    };
    
    checkSession();
  }, []);

  const handleContinue = () => {
    navigate("/login", { replace: true });
  };

  return (
    <div className="w-full min-h-[calc(100vh-4rem)] flex items-center justify-center bg-background">
      <div className="w-full max-w-md space-y-6 p-8 bg-card rounded-sm border border-border text-center">
        <div className="flex justify-center">
          <CheckCircle className="h-16 w-16 text-primary" />
        </div>
        <h1 className="text-2xl font-bold text-foreground">Email Confirmed!</h1>
        <p className="text-muted-foreground">
          Your email has been successfully verified. You can now access all features of Testera.
        </p>
        <Button 
          onClick={handleContinue} 
          className="w-full bg-primary hover:bg-primary/90 text-primary-foreground"
        >
          Continue to Login
        </Button>
      </div>
    </div>
  );
};

export default EmailConfirmed;
